import { type HTMLAttributes, type JSX } from 'react';

import { CardRoot } from './CardRoot';
import { CardBody } from './components/CardBody';
import { CardFooter } from './components/CardFooter';
import { CardHeader } from './components/CardHeader';

type CardComponent = {
  (props: HTMLAttributes<HTMLDivElement>): JSX.Element;
  Header: typeof CardHeader;
  Body: typeof CardBody;
  Footer: typeof CardFooter;
};

/* exemplo de export de componente com composição */
const Card = CardRoot as unknown as CardComponent;
Card.Header = CardHeader;
Card.Body = CardBody;
Card.Footer = CardFooter;

export { Card };
